import React from 'react'

// utils
import { createWeekDays } from './ScheduleWeek.utils.js'

// query
import { useQuery } from '@apollo/client'
import { GET_ALL_JOB_DAYS_IN_DATE_RANGE } from '../../../../graphql/jobDay/jobDay.queries'

// components
import Calendar from '../../../../components/calendar/Calendar/Calendar.component'

export default function ScheduleWeek({startDate, endDate}) {

    const { loading, error, data } = useQuery(GET_ALL_JOB_DAYS_IN_DATE_RANGE, {
        variables: { startDate, endDate },
        fetchPolicy: "network-only"
    })

    let weekDays = [...createWeekDays(startDate, endDate, [])]

    if(data && data.jobDaysInDateRange) {
        weekDays = createWeekDays(startDate, endDate, data.jobDaysInDateRange)
    }

    return (<Calendar dates={weekDays} />)
}